const initialState = {
  data: null,
};

const SET_PRICING = 'SET_PRICING';

export const setPricing = (payload) => ({
  type: SET_PRICING,
  payload,
});

export default function pricingReducer(state = initialState, action) {
  switch (action.type) {
    case SET_PRICING:
      return { ...state, data: action.payload };
      // return { ...state, data: action.payload.data.templates };
      default:
      return state;
  }
}
